import { Injectable, inject, signal } from '@angular/core';
import { InvitationService } from '@app/core/services/invitation.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { InvitationVerification } from './invitation-verification.model';
import { AuthenticationService } from '@app/core/services/authentication.service';

@Injectable({ providedIn: 'root' })
export class InvitationSandbox {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly invitationService = inject(InvitationService);

  readonly isValidatingInvitation = signal(false);
  readonly verifiedInvitation = this.invitationService.verifiedInvitation;
  readonly invitationCode = this.invitationService.invitationCode;

  verifyInvitation(invitationCode: string): Observable<InvitationVerification> {
    this.clearVerifiedInvitation();
    this.isValidatingInvitation.set(true);
    return this.invitationService
      .verifyInvitation(invitationCode)
      .pipe(
        finalize(() => this.isValidatingInvitation.set(false))
    );
  }

  linkUser(invitationId: string): Observable<void> {
    return this.invitationService
      .linkUser(invitationId);
  }

  clearVerifiedInvitation(): void {
    this.invitationService.clearVerifiedInvitation();
  }

  clearInvitationContext(): void {
    this.invitationService.clearInvitationContext();
  }

  logout(): void {
    this.authenticationService.logout();
  }
}
